module.exports = __webpack_public_path__ + "c669900b283f1718bd9f9ea5e49404fb.svg";